export default __webpack_public_path__ + "static/media/InstaSVG.a909891f.svg";